import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Badge,
  Button,
  Card,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  OutlinedInput,
  Stack,
  Typography,
  Chip,
  TextField,
  FormLabel,
  TextareaAutosize,
  FormControlLabel,
  Radio,
  RadioGroup,
  Paper
} from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import React, { useState, useRef, useEffect, useContext, useCallback } from "react";
import { useForm, Controller } from "react-hook-form";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import ImageUploading from "react-images-uploading";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import RichTextEditor from "react-rte";
import { toast } from "react-hot-toast";

import { uploadImageApi } from "../../store/upload/uploadImage";
import { useTheme } from '@mui/material/styles';
import { courseDiscussionCommentApi, resetCourseDiscussionComment } from "../../store/course-discussion/courseDiscussionCommentList"
import PublishUnpublishModule from "../../components/PublishUnpublishModulePost";
import DataGridComponent from "../../components/DataGridComponent";
import { getGridStringOperators } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import { ThemeContext } from '../../context/ThemeContext';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import NodataImg from "../../assets/images/noData.png";
import CustomGridToolbar from "../../components/CustomGridToolbar";
import apiRoutes from "../../store/apiConfigs";
import BackdropUI from "../../ui/Backdrop";
import { courseDiscussionCommentReplyEditApi } from "../../store/course-discussion/editCourseDiscussionCommentReply";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const schema = yup
  .object({
    content: yup.string().required("content cannot be empty").trim(),
  })
  .required();

export default function EditCourseDiscussionCommentReply() {

  const discussionCommentReplyEdit = useSelector((state) => state?.courseDiscussionCommentReplyEdit);

  const historyLocation = useLocation();
  const { postCommentReplyData, postCommentData, postId, postData, courseId: stateCourseId } = historyLocation.state || {};
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    control,
    setValue
  } = useForm({ resolver: yupResolver(schema), defaultValues: {} });
  const [images, setImages] = React.useState([]);
  const [imageLink, setImageLink] = useState();
  const [thumbnailLink, setThumbnail] = useState();
  const [isDownload, setIsDownload] = useState(false)
  const params = useParams();
  const courseId = params.courseId || stateCourseId;
  const [selectedRow, setSelectedRow] = useState([]);
  const [publishModel, setPublishModel] = useState(false);
  const navigate = useNavigate();
  const { paginationModel, setPaginationModel } = useContext(ThemeContext)
  const [queryOptions, setQueryOptions] = useState({});
  const onFilterChange = useCallback((filterModel) => {
    setQueryOptions({ filterModel: { ...filterModel } });
  }, []);
  const commentSelector = useSelector((state) => state?.courseDiscussionComments);
  const { result, loading, total } = commentSelector;

  const handleUpdateForm = async (data) => {
    if (params.id) {
      if (data.content === postCommentReplyData?.content) {
        navigate(`/courses/discussion/${courseId}/edit-discussion-comment/${postId}`, { state: { postData, courseId } });
        return;
      }
      let newObj = {
        content: data.content,
        reply_id: params.id
      };
      await dispatch(courseDiscussionCommentReplyEditApi(newObj));
      if (!discussionCommentReplyEdit?.loading) {
        navigate(`/courses/discussion/${courseId}/edit-discussion-comment/${postId}`, { state: { postData, courseId } });
      }
    }
  };

  useEffect(() => {
    let defalutValues = {};
    defalutValues["content"] = postCommentData?.content;
    reset(defalutValues);
  }, [postCommentData]);

  return (
    <>
      <Appbar />
      <Drawer />
      <Body>
        <form onSubmit={handleSubmit(handleUpdateForm)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card>
                <Typography>Reply Details</Typography>
                <Stack spacing={2} my={2}>
                  <Divider />
                  <>
                    <InputLabel htmlFor="outlined-adornment-email" shrink>
                      Content
                    </InputLabel>
                    <OutlinedInput
                      {...register("content")}
                      notched
                      multiline
                      id="outlined-adornment-content"
                      error={errors?.content?.message}
                      defaultValue={postCommentReplyData?.content}
                    />
                  </>
                </Stack>
                <Button
                  type="submit"
                  sx={{ float: "right", mt: 2, ml: 2 }}
                  variant="contained"
                  onClick={() => navigate(`/courses/discussion/${courseId}/edit-discussion-comment/${postId}`, { state: { postData, postCommentData, courseId } })}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  sx={{ float: "right", mt: 2 }}
                  variant="contained"
                >
                  Update
                </Button>
              </Card>
            </Grid>
          </Grid>
        </form>
      </Body>
    </>
  );
}
